import { useApi } from "@mb-pro-ui/utils";
import { useQuery } from "react-query";
import type { EntitySearchResponse } from "./types";

export const MIN_QUERY_LENGTH = 2;

// The search action matches account and unitid exactly, name, address and
// email accent-insensitively and phone numbers in two tiers. Inactive
// customers are included because `active=true` is never sent.
export function useCustomerSearch(query: string) {
  const api = useApi();
  const q = query.trim();
  return useQuery(
    ["entity-search", "customers", q],
    ({ signal }) =>
      api<EntitySearchResponse>(
        `/actions/alarm/entity-search?${new URLSearchParams({
          q,
          limit: "50",
          types: "customers",
        })}`,
        { signal },
      ),
    {
      enabled: q.length >= MIN_QUERY_LENGTH,
      keepPreviousData: true,
      staleTime: 30 * 1000,
      select: (data) => data.results.customers ?? [],
    },
  );
}
